export type IAgFormFourthSectionInterface = {
    PropertyId?: string,
    TotalAcreage?: string,
    PropertyLegalDescription?: string,
    DidDistrictAllow1D1Apraisal?: boolean,
    HasPropertyOwnershipChanged?: boolean,
    HasFormerOwnerPassedAway?:boolean,
    IsSurvivingSpouse?:boolean,
    IsNewOwnerUsingtheLandinMaterially?: boolean,
    WasAllowed1D1Appraisal?: boolean,
    IsThisPropertyLocatedWithinTheCorporateLimitsOfaCityorTown?: boolean
}

export const AgFormFourthSectionInitialState = (): IAgFormFourthSectionInterface => ({
    PropertyId: undefined,
    TotalAcreage: undefined,
    PropertyLegalDescription: undefined,
    DidDistrictAllow1D1Apraisal: undefined,
    HasPropertyOwnershipChanged: undefined,
    IsSurvivingSpouse:undefined,
    HasFormerOwnerPassedAway:undefined,
    IsNewOwnerUsingtheLandinMaterially: undefined,
    WasAllowed1D1Appraisal: undefined,
    IsThisPropertyLocatedWithinTheCorporateLimitsOfaCityorTown: undefined
})
